import { CLASS_ASIDE_PANEL } from '../../constants';

export const CLASS_ASIDE_PANEL_BODY = CLASS_ASIDE_PANEL + '__body';
export const CLASS_ASIDE_PANEL_CONTAINER_ACTIONS = CLASS_ASIDE_PANEL + '__container-actions';
export const CLASS_ASIDE_PANEL_CONTAINER_ACTIONS_BODY = CLASS_ASIDE_PANEL + '__container-actions-body';

export const ASIDE_PANEL_HEADER_HEIGHT = 56;
